import styled from "styled-components";
import { black, mainFont } from "../../utils/StyleHelpers";

export const StyledPagination = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  width: 71.38rem;
  color: ${black};
  text-align: center;
  font-family: ${mainFont};
  font-size: 1rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const FilterButton = styled.div`
  padding: 0.625rem 0rem;
  flex-direction: column;
  justify-content: center;
  gap: 0.625rem;
  border-radius: 0.5rem;
  border: 1px solid ${black};
  background: #fff;
`;

export const Selection = styled.select`
  gap: 0.625rem;
  color: ${black};
  font-family: ${mainFont};
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  border: 0;
`;
